export default __webpack_public_path__ + "static/media/screen_telegram_1.6a4307de.png";